import MultiSelectRenderer from './MultiSelectRenderer';
import EnumRenderer from './EnumRenderer';
import TextRenderer from './TextRenderer';
import DateRangeRenderer from './DateRangeRenderer';
import NumberRangeRenderer from './NumberRangeRenderer';

const RENDERERS = {
    multiselect: MultiSelectRenderer,
    enum: EnumRenderer,
    boolean: EnumRenderer,
    text: TextRenderer,
    date: DateRangeRenderer,
    number: NumberRangeRenderer,
};

export const getRenderer = (type) => RENDERERS[type] || TextRenderer;
